import React from 'react'

import './servicePage.scss'
import PropTypes from 'prop-types'

const ServicePage = ({ title, subtitle, description, action, image, benefits, className }) => {
  return <div className={`Suc-service-page ${className}`}>
    <div className="Suc-top">
      <div className="Suc-main">
        <div className="Suc-title">{title}</div>
        <div className="Suc-sub-title">{subtitle}</div>
        <div className="Suc-description">{description}</div>
        <div className="Suc-action">{action}</div>
      </div>
      <div className="Suc-image">
        {image}
      </div>
    </div>
    <div className="Suc-bottom">
      {benefits && benefits.map(({ icon, title, description }) => {
        return <div className="Suc-benefit" key={title}>
          <div className="Suc-icon">{icon}</div>
          <div className="Suc-title">{title}</div>
          <div className="Suc-description">{description}</div>
        </div>
      })}
    </div>
  </div>
}

const benefitShape = {
  icon: PropTypes.node,
  title: PropTypes.node,
  description: PropTypes.node
}
ServicePage.propTypes = {
  /** page title */
  title: PropTypes.node,
  /** page sub title */
  subtitle: PropTypes.node,
  /** page description */
  description: PropTypes.node,
  /** action component */
  action: PropTypes.node,
  /** image element */
  image: PropTypes.node,
  /** image element */
  benefits: PropTypes.arrayOf(PropTypes.shape(benefitShape)),
  /** custom classname */
  className: PropTypes.string
}

ServicePage.defaultProps = {
  benefits: [],
  className: ''
}

export default ServicePage
